<template>
  <div class="container containerWy">
    <!-- <div ref="containerTop" class="containerTop">
      <a href="" target="_blank">
        <img src="../assets/img/big_advert.jpg" alt="" />
      </a>
    </div>
    
    <el-collapse-transition>
      <div class="containerAd" v-show="viewAdSmall">
        <a href="" target="_blank">
          <img src="../assets/img/small_advert.jpg" alt="" />
        </a>
      </div>
    </el-collapse-transition> -->

    <div class="topImg" ref="topImg">
      <img :src="content.fileName" style="width: 100%" v-if="viewImgTop" />
    </div>

    <div class="containerWrap" :style="containerStyle">

      <div class="headerMiddle">
        <div class="wrap clearfloat">
          <div class="fl headerMiddleLeft">
            <a href="/"> <img src="../assets/img/logo_wy1.png" alt=""/></a>
          </div>
          <div class="fr headerMiddleRight">
            <div class="headerRInner headerRInnerFont">
              <span v-if="viewFont" @click="onSwitchLanguage('t')">繁體</span>
              <span v-if="!viewFont" @click="onSwitchLanguage('s')">简体</span>
            </div>
            <div class="headerRInner headerRInnerPhone">
              <a href=""><i class="el-icon-mobile-phone"></i> 手机版</a>
            </div>
            <div class="headerRInner headerRInnerSearch">
              <span @click="handleSearchBtn">
                <i class="el-icon-search"></i>
              </span>
              <div class="headerRInnerSearchBox" v-if="viewSearch">
                <el-input
                  v-model="searchValue"
                  size="small"
                  placeholder="请输入关键词"
                  style="width: 200px; margin-right: 5px;"
                ></el-input>
                <el-button
                  type="submit"
                  class="btn"
                  size="small"
                  icon="el-icon-search"
                  @click="handleSearch"
                ></el-button>
              </div>
            </div>
            <!-- <div class="header_search">
              <div class="headerSearchBox">
                <el-input v-model="searchValue" placeholder="请输入关键词" style="width: 260px"></el-input>
                <el-button type="submit" class="btn" icon="el-icon-search" @click="handleSearch"></el-button>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="header">
        <div class="wrap clearfloat">
          <div class="nav_box">
            <ul class="clearfloat">
              <li :class="{ active: active == 0 }">
                <div class="nav_grop">
                  <h2><a href="/">网站首页</a></h2>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" :class="{ active: active == item.id }">
                <div class="nav_grop" @mouseenter="navShow(item.channelId)" @mouseleave="navClose()">
                  <h2 v-if="item.name == '服务项目'">
                    <a :href="`/listImages/00130001`">
                      {{ item.name }}
                    </a>
                  </h2>
                  <h2 v-else-if="item.name == '人力资源'">
                    <a :href="`/list/00170001`">
                      {{ item.name }}
                    </a>
                  </h2>
                  <h2 v-else>
                    <a :href="`${item.url}`">
                      {{ item.name }}
                    </a>
                  </h2>
                  <!-- <h2>
                    <a
                      v-if="item.child.length && item.child[0].url && item.child[0].url !== ''"
                      target="_blank"
                      :href="item.url"
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="item.child.length && (!item.child[0].url || item.child[0].url == '')"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/listPic/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="!item.child.length"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/listPic/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2> -->
                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap clearfloat" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <a
                            v-if="item1.url && item1.url !== ''"
                            target="_blank"
                            :href="`/listImages/${item1.entTChannelUuid}`"
                          >
                            {{ item1.name }}
                          </a>
                          <a
                            v-if ="!item1.url || item1.url == ''"
                            :href="
                              item1.catalog === 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog === 2 || item1.catalog === 3
                                ? `/list/${item1.entTChannelUuid}`
                                : `/listImages/${item1.entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                          <!-- <a
                            v-else
                            target="_blank"
                            :href="`/list/00190001`"
                          >
                            {{ item1.name }}
                          </a> -->
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
      <div class="footer">
        <div class="footerWrap">
          <div class="wrap">
            <div class="footerBottom">
              <p>
                <span
                  >Copyright © 2014 <a href="https://beian.miit.gov.cn" target="_balnk">陇ICP备19002678号-1</a></span
                >
                <span>
                  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502000424" target="_balnk"
                    >甘公网安备 62010502000424号</a
                  >
                </span>
                <span>版权所有 甘肃建投城市运营服务集团有限公司</span>
              </p>
              <p>
                <span>
                  地址：兰州市安宁区安宁东路940号
                </span>
                <span>
                  电话：0931-8361672
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel ,getAdvert} from '@/api/common'

export default {
  name: '',
  data() {
    return {
      content: '',
      viewImgTop: true,
      viewSearch: false,
      viewFont: true,
      viewAdSmall: false,
      containerStyle: {},
      viewTop: false,
      txtImg: '',
      searchValue: '',
      active: 0,
      navList: [],
      navDown: 0,
      lang: 's'
    }
  },
  mounted() {
    this.getPath()
    this.footerImg()
    this.getNavChannel()
    // this.srollTop()
    let url = this.$route.name
    if (url == 'home') {
      this.srollimg()
    }

    this.$nextTick(() => {
      this.$zh_tran(localStorage.getItem('lang'))
    })
    // let url = this.$route.name
    // if (url == 'home') {
    //   this.srollTop()
    // }
    // setTimeout(() => {
    //   this.viewTop = true
    // }, 500);
    // setTimeout(() => {
    //   this.viewTop = false
    // }, 2000)
  },
  created() {},
  watch: {
    $route: 'getPath'
    // $route(to) {
    //   console.log('to :>> ', to);
    //   this.$nextTick(() => {
    //     this.$zh_tran(localStorage.getItem('lang'))
    //     this.getPath()
    //   })
    // }
  },
  methods: {
    // 字体切换
    onSwitchLanguage(val) {
      // console.log('val :>> ', val);
      this.lang = val
      if (val == 's') {   //简体
        this.viewFont = true
        localStorage.setItem('lang', 's')
        
      } else {     //繁体
        this.viewFont = false
        localStorage.setItem('lang', 't')
      }
      this.$zh_tran(localStorage.getItem('lang'))
    },
    handleSearchBtn() {
      var _this = this

      _this.viewSearch = !_this.viewSearch
    },
    // srollTop() {
    //   var _this = this
    //   var heightT
    //   setTimeout(() => {
    //     heightT = this.$refs.containerTop.offsetHeight - 10
    //     _this.containerStyle = {
    //       marginTop: heightT + 'px'
    //     }
    //   }, 1500)
    //   setTimeout(() => {
    //     _this.containerStyle = {
    //       marginTop: 0
    //     }
    //   }, 5000)
    //   setTimeout(() => {
    //     _this.viewAdSmall = true
    //   }, 6500)
    // },
    srollimg() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 4
      }
      getAdvert(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          data.length && (_this.content = data[0])
          this.$nextTick(() => {
            this.srollTop()
          })
        }
      })
    },

    srollTop() {
      var _this = this
      var heightT
      this.$refs.topImg && setTimeout(() => {
        heightT = this.$refs.topImg.offsetHeight
        _this.containerStyle = {
          marginTop: heightT + 'px'
        }
      }, 600)
      setTimeout(() => {
        _this.containerStyle = {
          marginTop: 0
        }
      }, 3000)
      setTimeout(() => {
        _this.viewImgTop = false
      }, 6000)
    },


    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 7)
          // data.length &&
          //   data.forEach((line, index) => {
          //     if (line.child.length) {
          //       line.url = _this.navList[index].index + '/' + line.child[0].entTChannelUuid
          //     } else {
          //       line.url = _this.navList[index].index + '/' + line.entTChannelUuid
          //     }
          //   })
          // _this.navSubList = [
          //   {
          //     id: 1,
          //     name: '网站首页',
          //     url: '/'
          //   },
          //   ...data
          // ]
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
        // window.open(`/search/${_this.searchValue}`)
      }
    },
    // 二级导航展开
    navShow(d) {
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose() {
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params) {
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath() {
      var _this = this

      _this.active = _this.$route.meta.index
    },
    footerImg() {
      var _this = this

      _this.txtImg = unescape(
        "%3Cspan id='cnzz_stat_icon_1259563611'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/stat.php%3Fid%3D1259563611%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"
      )
      // console.log('txtImg :>> ', _this.txtImg)
    }
  }
}
</script>
<style>
.topImg {
    position: fixed;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    z-index: -10;
    overflow: hidden;
    -moz-transition: all 2s ease-out;
    -webkit-transition: all 2s ease-out;
    -o-transition: all 2s ease-out;
    transition: all 2s ease-out;
}

.topImg img {
    width: 100%;
    height: 100%;
    display: block;
}
.containerWrap {
    -moz-transition: all 2s ease-out;
    -webkit-transition: all 2s ease-out;
    -o-transition: all 2s ease-out;
    transition: all 2s ease-out;
    z-index: 10;
    background-color: #fff;
}
.headerTop {
  line-height: 32px;
  color: #fff;
  background-color: #484647;
  font-size: 14px;
}
.headerTopRight span {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}
.headerTopRight span i {
  font-size: 18px;
  vertical-align: top;
  display: inline-block;
  line-height: 32px;
}
.headerMiddle {
  padding: 30px 0 20px;
}
.headerMiddleLeft img {
  /* width: 700px; */
  height: 100px;
}
.headerMiddleRight {
  margin-top: 28px;
}
.header_search {
  /* width: 380px; */
  height: 32px;
  overflow: hidden;
  float: right;
  position: relative;
  line-height: 32px;
  font-size: 14px;
  color: #585858;
  border: solid 1px #0d65af;
  border-radius: 10px;
}
.header_search input {
  height: 32px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 38px;
  font-size: 14px;
  color: #000;
  border-radius: 0px;
  border: none;
  vertical-align: top;
}
.header_search .el-button {
  width: 40px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  border: none;
  vertical-align: top;
  font-weight: bold;
}
.header {
  text-align: center;
  background-color: #017bce;
  /* background-image: url(../assets/img/header_bg.png); */
  /* background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(13,30,46,.8); */
  /* position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 22; */
}
.headerLogo {
  margin-top: 6px;
  /* margin-bottom: 20px; */
}
.headerLogo img {
  /* width: 360px; */
  height: 46px;
  width: auto;
  vertical-align: middle;
}
.headerNavTxt {
  display: inline-block;
  min-width: 45px;
  color: #fff;
  font-size: 20px;
  letter-spacing: 4px;
  cursor: pointer;
}
.headerNavTxt:hover {
  color: #bc8f68;
}
.main {
  min-height: 500px;
}
.footer {
  background: #484647;
  color: #fff;
}
.footerWrap {
  padding: 30px 0;
  text-align: left;
}
.footerLeft {
  padding-top: 46px;
}
.footerLeft .pic {
  text-align: center;
}
.footerLeft img {
  width: 94px;
  height: auto;
  margin: 0 30px;
}
.footerLeft .txt {
  height: 30px;
  line-height: 30px;
  color: #80b2db;
  font-size: 13px;
}
.footerRight {
  padding-left: 120px;
}
.footerRightTitle {
  font-size: 35px;
  line-height: 35px;
  margin-bottom: 15px;
}
.footerRightInner {
  font-size: 16px;
  line-height: 30px;
}
.footerRightInner span {
  display: block;
}
.footerRightInner a {
  color: #fff;
}
.footerRightInner.bt,
.footerRightInner.bt a {
  color: #80b2db;
}

.nav_box {
  /* height: 38px; */
  /* background-color: #1970b9; */
  line-height: 54px;
}
.nav_box ul li {
  height: 54px;
  line-height: 54px;
  float: left;
  width: 12.5%;
  color: #fff;
  text-align: center;
  position: relative;
}
/* .nav_box ul li a {
  display: block;
} */
.nav_grop {
  /* width: 82px; */
  height: 100%;
  /* margin: 5px auto 0; */
  position: relative;
}
.nav_box ul li h2 {
  text-align: center;
  height: 100%;
  font-size: 16px;
  overflow: hidden;
}
.nav_box ul li h2 a {
  width: 90px;
  height: 54px;
  margin: 0 auto;
  display: block;
  color: #fff;
  border-bottom: 2px solid #017bce;
  box-sizing: border-box;
}
.nav_grop:hover h2 {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.nav_grop:hover h2 a {
  /* background-color: #074378; */
  border-bottom: 2px solid #fff;
}
.nav_box ul li.active h2 a {
  /* background-color: #074378; */
  border-bottom: 2px solid #fff;
}
.nav_down {
  position: absolute;
  width: 100%;
  left: 0;
  top: 64px;
  z-index: 6666;
}
.nav_down_wrap {
  padding: 1px 0 0 0;
  border-top: none;
  background-color: rgba(7, 67, 120, 0.6);
}
.nav_down p {
  line-height: 64px;
  text-align: center;
  font-size: 18px;
}
.nav_down p a {
  display: block;
  color: #fff;
}
.nav_down p a:hover {
  background-color: #074378;
}
.header_hd {
  height: 34px;
  line-height: 34px;
  /* background-image: url("../assets/img/st_03.jpg"); */
  background-repeat: repeat-x;
  background-size: auto 100%;
  padding: 0 25px;
  font-size: 12px;
}
.header_top {
  padding: 10px;
}
.mobile {
  display: block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 600;
}

.mobile:hover {
  color: #d60f0f;
}
.user_input {
  display: inline-block;
  width: 120px;
}
.user_l {
  display: inline-block;
  margin-left: 10px;
}
.user_sure {
  margin: 0 4px 0 6px;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border: 1px solid #b6b6b6;
  cursor: pointer;
  vertical-align: top;
  margin-top: 3px;
  background-color: #e9e9e9;
  border-radius: 2px;
}
.user_sure:hover {
  background-color: #dddddd;
}
.user_forget:hover {
  color: #d60f0f;
  text-decoration: underline;
}
.mail_dsz {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  color: #d60f0f;
  margin-left: 30px;
}
.mail_dsz:hover {
  border-color: #d60f0f;
}
.user_wrap {
  display: inline-block;
}
.footerBotttom {
  text-align: center;
}
.topLogoMainRight {
  position: absolute;
  width: 380px;
  height: 50px;
  overflow: hidden;
  bottom: 10px;
  right: 0;
}
.topLogoMainRight .el-input__inner {
  background-color: rgba(255, 255, 255, 0.5);
}
.topLogoMainRight .el-button {
  border: none;
}
.topLogoMainRight {
  float: right !important;
}
.footerBottom {
  color: #f7f7f7;
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
  line-height: 24px;
}
.footerBottom a {
  color: #f7f7f7;
  font-size: 16px;
}

/* 物业集团 */
.containerWy .headerTop {
  display: none;
}
.containerAd {
  -moz-transition: all 1s ease-in;
  -webkit-transition: all 1s ease-in;
  -o-transition: all 1s ease-in;
  transition: all 1s ease-in;
}
.containerAd img {
  width: 100%;
  height: auto;
}
.containerWy .header {
  background-color: transparent;
  margin-top: 222px;
}
.containerWy .nav_box {
  background: #0062b3;
  border-radius: 4px 4px 0 0;
}
.containerWy .nav_box ul li {
  height: 60px;
  line-height: 60px;
}
.containerWy .nav_box ul li h2 a {
  font-size: 18px;
  width: auto;
  border: none;
  height: auto;
}
.containerWy .nav_down {
  top: 60px;
}
.containerWy .nav_box ul li.active a,
.containerWy .nav_box ul li:hover h2 a {
  background: #84c0f1;
  font-weight: bold;
}
.containerWy .nav_down p {
  border-top: solid 1px #fff;
}
.containerWy .nav_down_wrap {
  border: none;
  padding: 0;
  background: #84c0f1;
}
.containerWy .nav_down p a:hover {
  background: #0062b3;
}
.containerWy .containerWrap {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
  background-image: url('../assets/img/header_bg.png');
}
.headerRInner {
  display: inline-block;
  margin-left: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.headerRInner span {
  display: block;
}
.headerRInner a {
  color: #fff;
}
.headerRInnerSearch {
  position: relative;
}
.headerRInnerSearchBox {
  width: 250px;
  position: absolute;
  top: 36px;
  right: 0;
  padding: 6px 10px;
  border-radius: 3px;
  background-color: #fff;
}
.containerWy .footerBottom {
  font-size: 16px;
  line-height: 30px;
  padding-top: 10px;
}
.containerWy .footerBottom span {
  display: inline-block;
  margin: 0 10px;
}
</style>
